import React from 'react';
import VersionDropdown from '../VersionDropdown';

export const UnifiedVersionDropdown = ({ contentSite }: { contentSite?: string }) => {
  return <VersionDropdown contentSite={contentSite} />;
};
